import React, { useState } from "react";
import { ActivityIndicator, Dimensions, Image as Img, Platform, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS } from "@voltmoney/schema";
import { ModalAlignmentEnum } from '@voltmoney/types';
import { Typography } from "../../typography/Typography";
import CustomHeader from "../../customHeader/CustomHeader";
import { FRAME_ICON } from "../borrowerLandingPage/constant";
let SvgUri;
if (Platform.OS !== 'web') {
    SvgUri = require('react-native-svg').SvgUri;
}
// import {SvgUri} from "react-native-svg";
import { Divider } from "../../divider/Divider";
import { addCommasToNumber, getScreenType, isFromTDLPlatform } from "../utils";
import { isMobile } from "../../stack/utils";
import { Icon } from "../../icon/Icon";
import BottomSheet from "../BottomSheet";
import { Button } from "../../button/Button";
import Space from "../../space/Space";
import ThemeProvider from "@voltmoney/theme";
const ManageLimitLanding = ({ height, viewDetailsAction, triggerAction, faqsAction, goBack, applicationStage, existingCreditLimit, needHelpAction, lastFetchedDate, isEditLimitEnabled, checkEligibleLimitAction, continueEditLimitAction, continueApplicationAction, selectedCreditLimit, loading, availableToUnlock, continueUnlockLimitAction, approvedCreditLimit, editLimitLoader, unlockLimitLoader, showNavNextLoader, }) => {
    const [howItWorks, setHowItWorks] = useState(false);
    const [onEditLimitPressed, setOnEditLimitPressed] = useState(false);
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const isfromTDL = isFromTDLPlatform();
    const renderEditLimitConfirmationBox = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: -4 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS === "ios" ? 292 : 272, width: '100%', alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, closeFunction: () => {
                    setOnEditLimitPressed(false);
                } },
                React.createElement(View, { style: {
                        justifyContent: 'center',
                        padding: 16,
                        paddingTop: 24,
                        alignContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
                    React.createElement(View, { style: { marginTop: 24, marginBottom: 24 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: "Are you sure you want to edit your limit? This will reset your selected limit", textAlign: TextAlignTokens.center })),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Yes, continue to edit limit", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            triggerAction({
                                ...continueEditLimitAction
                            });
                        }, loading: editLimitLoader }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: "No, continue with selected limit", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setOnEditLimitPressed(false);
                        } })))));
    };
    const renderHowItWorksCard = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0, marginBottom: -4 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: Platform.OS === "ios" ? 352 : isMobile(getScreenType(Dimensions.get('window').width)) ? 346 : 320, width: '100%', closeFunction: () => {
                    setHowItWorks(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height : Dimensions.get('window').height + 10 : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true },
                React.createElement(View, { style: { paddingHorizontal: 16, paddingTop: 24, paddingBottom: 16 } },
                    React.createElement(Typography, { label: "Unlock more limit in just 3 steps", typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                alignContent: 'flex-start',
                                alignItems: 'flex-start',
                                alignSelf: 'flex-start',
                                justifyContent: 'flex-start'
                            } },
                            React.createElement(View, { style: { width: 40 } },
                                React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/eligible_credit_limit.png" }, style: { width: 40, height: 40 } }),
                                React.createElement(View, { style: {
                                        ...StyleSheet.absoluteFillObject,
                                        height: 28,
                                        alignContent: 'center',
                                        alignSelf: 'center',
                                        width: 1,
                                        marginTop: 42,
                                        marginLeft: 20,
                                        backgroundColor: '#E4E7EC',
                                    } })),
                            React.createElement(View, { style: { marginLeft: 12 } },
                                React.createElement(Typography, { label: "Check eligible credit limit", typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: "It only takes 15 seconds", typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(View, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                            React.createElement(View, { style: { width: 40 } },
                                React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/verify_interest_charges.png" }, style: { width: 40, height: 40 } }),
                                React.createElement(View, { style: {
                                        ...StyleSheet.absoluteFillObject,
                                        height: 28,
                                        alignContent: 'center',
                                        alignSelf: 'center',
                                        width: 1,
                                        marginTop: 42,
                                        marginLeft: 20,
                                        backgroundColor: '#E4E7EC',
                                    } })),
                            React.createElement(View, { style: { marginLeft: 12 } },
                                React.createElement(Typography, { label: "Verify interest & charges", typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: isMobile(getScreenType()) ? "Confirm interest rate, processing fee, &\nany charges that may be applicable" : "Confirm interest rate, processing fee, & any charges that may be applicable", typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(View, { style: { flexDirection: 'row', alignContent: 'center', alignItems: 'center' } },
                            React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/withdraw_cash.png" }, style: { width: 40, height: 40 } }),
                            React.createElement(View, { style: { marginLeft: 12 } },
                                React.createElement(Typography, { label: "Finish application & withdraw cash", typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Grey_Night, lineHeight: 20 }),
                                React.createElement(View, { style: { marginTop: 4 } },
                                    React.createElement(Typography, { label: "Get cash in your account within 2 business hours", typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal }))))),
                    React.createElement(View, { style: { marginTop: 24 } },
                        React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Ok, got it!", fontSize: FontSizeTokens.SM, onPress: () => {
                                setHowItWorks(false);
                            } }))))));
    };
    return (React.createElement(View, { style: { height: height, marginHorizontal: -16 } },
        React.createElement(CustomHeader, { goBackAction: goBack, triggerAction: triggerAction, needHelpAction: needHelpAction, goBackId: "btn_ManageLimit_goBack", needHelpId: "btn_ManageLimit_needHelp" }),
        React.createElement(View, { style: { height: height - 58, backgroundColor: colorMapping[ColorTokens.Primary_05] } },
            applicationStage === "PRE_FETCH" ?
                React.createElement(View, { style: { backgroundColor: 'white' } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            paddingHorizontal: 16,
                            paddingTop: 24,
                            paddingBottom: 16,
                            backgroundColor: 'white',
                            alignContent: 'center',
                            alignItems: 'center',
                        } },
                        React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/rupee_stack.png" }, style: { height: 83, width: 56 }, resizeMode: 'cover' }),
                        React.createElement(View, { style: { justifyContent: 'center', marginLeft: 16 } },
                            React.createElement(Typography, { typeDLS: Platform.OS !== "web" ? TypographyTypeDLS.H3B : TypographyTypeDLS.H3S, label: "Increase credit limit", color: ColorTokens.Grey_Night, lineHeight: 24 }),
                            React.createElement(View, { style: { marginTop: 4 } },
                                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: "Unlock additional limit instantly", color: ColorTokens.Grey_Charcoal, lineHeight: 18 })))),
                    React.createElement(TouchableOpacity, { style: [styles.frameButtonContainer, { backgroundColor: colorMapping[ColorTokens.Primary_100], borderRadius: isfromTDL ? 8 : 1000 }], onPress: () => {
                            triggerAction({
                                ...checkEligibleLimitAction
                            });
                        } },
                        React.createElement(View, { style: styles.eligibleText },
                            React.createElement(Typography, { label: "Check eligibility in 15s", fontSize: FontSizeTokens.SM, fontWeight: '600', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.White, lineHeight: Platform.OS !== "web" ? 22 : 20 })),
                        React.createElement(View, { style: styles.iconContainer }, Platform.OS !== 'web' ?
                            React.createElement(SvgUri, { uri: FRAME_ICON, style: { marginTop: 3 } }) :
                            React.createElement(React.Fragment, null,
                                React.createElement(Img, { source: { uri: FRAME_ICON }, style: { width: 24, height: 24 } }))),
                        loading && React.createElement(View, { style: styles.iconContainer },
                            React.createElement(ActivityIndicator, { style: {
                                    marginLeft: 8
                                }, size: 20, animating: true, color: 'white' }))),
                    React.createElement(View, { style: { marginHorizontal: -16, marginTop: 16 } },
                        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))) :
                isEditLimitEnabled ?
                    React.createElement(View, { style: { backgroundColor: 'white', padding: 16 } },
                        React.createElement(Typography, { label: "Unlock additional credit limit", typeDLS: Platform.OS !== "web" ? TypographyTypeDLS.H3B : TypographyTypeDLS.H3S, lineHeight: 24, color: ColorTokens.Grey_Night }),
                        React.createElement(View, { style: { marginTop: 4 } },
                            React.createElement(Typography, { label: `Last fetched on ${lastFetchedDate === null ? '' : lastFetchedDate}`, typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(View, { style: {
                                borderTopRightRadius: 16,
                                borderTopLeftRadius: 16,
                                borderWidth: 1,
                                borderColor: '#E4E7EC',
                                paddingTop: 16,
                                paddingBottom: 14,
                                paddingLeft: 16,
                                paddingRight: 16,
                                flexDirection: 'column',
                                marginTop: 12,
                                height: 98,
                                shadowColor: '#98A2B3',
                                zIndex: 1,
                                shadowOffset: {
                                    width: 0,
                                    height: 1,
                                },
                                shadowOpacity: 0.20,
                                shadowRadius: 4.65,
                            } },
                            React.createElement(View, { style: { flexDirection: 'row', alignItems: 'center', alignContent: 'center' } },
                                React.createElement(View, { style: {
                                        width: 52,
                                        height: 52,
                                        backgroundColor: "#F1F3F5",
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 6
                                    } },
                                    React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png" }, style: { width: 42, height: 42 } })),
                                React.createElement(View, { style: { marginLeft: 12 } },
                                    React.createElement(Typography, { label: "Selected credit limit", typeDLS: TypographyTypeDLS.B1R, lineHeight: 20, color: ColorTokens.Grey_Charcoal }),
                                    React.createElement(Typography, { label: `₹${addCommasToNumber(selectedCreditLimit)}`, lineHeight: 32, fontWeight: "700", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXL, color: ColorTokens.Secondary_100 })))),
                        React.createElement(View, { style: {
                                backgroundColor: '#F9FAFB',
                                borderBottomRightRadius: 16,
                                borderBottomLeftRadius: 16,
                                borderWidth: 1,
                                borderColor: "#E4E7EC",
                                paddingHorizontal: 20,
                                paddingVertical: 6,
                                zIndex: 1,
                                shadowOffset: {
                                    width: 0,
                                    height: 1,
                                },
                                shadowOpacity: 0.20,
                                shadowRadius: 4.65,
                            } },
                            React.createElement(Typography, { label: `Available limit: ₹${addCommasToNumber(availableToUnlock)}`, typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal })),
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                alignContent: 'center',
                                alignItems: 'center',
                                width: '100%',
                                justifyContent: 'center',
                                paddingTop: 12,
                                paddingBottom: 8
                            } },
                            React.createElement(View, { style: { width: '40%', marginRight: 8, height: 32 } },
                                React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: "Edit limit", fontSize: FontSizeTokens.XS, onPress: () => {
                                        setOnEditLimitPressed(true);
                                    }, loading: loading })),
                            React.createElement(View, { style: { width: '60%', height: 32 } },
                                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Unlock limit", onPress: () => {
                                        triggerAction({
                                            ...continueApplicationAction
                                        });
                                    }, loading: unlockLimitLoader }))))
                    :
                        React.createElement(View, { style: { backgroundColor: 'white', padding: 16 } },
                            React.createElement(Typography, { label: "Unlock additional credit limit", typeDLS: Platform.OS !== "web" ? TypographyTypeDLS.H4B : TypographyTypeDLS.H4S, lineHeight: 24, color: ColorTokens.Grey_Night }),
                            React.createElement(View, { style: { marginTop: 4 } },
                                React.createElement(Typography, { label: `Last fetched on ${lastFetchedDate === null ? '' : lastFetchedDate}`, typeDLS: TypographyTypeDLS.B2R, lineHeight: 18, color: ColorTokens.Grey_Charcoal })),
                            React.createElement(View, { style: {
                                    borderRadius: 16,
                                    borderWidth: 1,
                                    borderColor: '#E4E7EC',
                                    padding: 16,
                                    flexDirection: 'row',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    marginTop: 12,
                                    height: 88
                                } },
                                React.createElement(View, { style: {
                                        width: 52,
                                        height: 52,
                                        backgroundColor: "#F1F3F5",
                                        justifyContent: 'center',
                                        alignContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: 6
                                    } },
                                    React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_assets.png" }, style: { width: 42, height: 42 } })),
                                React.createElement(View, { style: { marginLeft: 12 } },
                                    React.createElement(Typography, { label: "Available to unlock", typeDLS: TypographyTypeDLS.B1R, lineHeight: 20, color: ColorTokens.Grey_Charcoal }),
                                    React.createElement(Typography, { label: `₹${applicationStage === "POST_PLEDGE" ? addCommasToNumber(approvedCreditLimit) : addCommasToNumber(availableToUnlock)}`, lineHeight: 32, fontWeight: "700", fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXL, color: ColorTokens.Secondary_100 }))),
                            React.createElement(View, { style: { marginTop: 12 } },
                                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Unlock limit", onPress: () => {
                                        triggerAction({
                                            ...continueUnlockLimitAction
                                        });
                                    }, loading: unlockLimitLoader }))),
            React.createElement(View, null,
                React.createElement(View, { style: { marginHorizontal: -16, marginTop: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(View, { style: { padding: 16, backgroundColor: 'white' } },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            alignItems: 'center'
                        } },
                        React.createElement(View, null,
                            React.createElement(Typography, { label: "Existing credit limit", typeDLS: TypographyTypeDLS.B1M, lineHeight: 20, color: ColorTokens.Grey_Night }),
                            React.createElement(View, { style: { marginTop: 4 } },
                                React.createElement(Typography, { label: `₹${addCommasToNumber(existingCreditLimit)}`, color: ColorTokens.Secondary_100, fontSize: FontSizeTokens.MD, fontWeight: "600", fontFamily: FontFamilyTokens.Inter, lineHeight: 24 }))),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                !showNavNextLoader && triggerAction({
                                    ...viewDetailsAction
                                });
                            }, style: { flexDirection: 'row', alignItems: 'center' } },
                            React.createElement(Typography, { label: "View details", typeDLS: Platform.OS !== "web" ? TypographyTypeDLS.B0B : TypographyTypeDLS.B0S, color: ColorTokens.Primary_100, lineHeight: 20 }),
                            React.createElement(View, { style: { marginTop: 2 } }, showNavNextLoader ? (React.createElement(ActivityIndicator, { color: theme.colors[ColorTokens.Primary_100], style: { left: 4 }, size: 16 })) :
                                React.createElement(Icon, { name: IconTokens.CHEVRON_BLUE_RIGHT, color: ColorTokens.Primary_100 })))))),
            React.createElement(View, null,
                React.createElement(View, { style: { marginHorizontal: -16, marginTop: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(TouchableOpacity, { style: {
                        paddingHorizontal: 16,
                        paddingVertical: 18,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: 'white',
                        alignItems: 'center',
                        alignContent: 'center'
                    }, onPress: () => {
                        setHowItWorks(true);
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row', alignItems: 'center',
                            alignContent: 'center'
                        } },
                        React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/howItWorks.png" }, style: { width: 24, height: 24 } }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { label: "How it works?", typeDLS: TypographyTypeDLS.B1M, lineHeight: 20, color: ColorTokens.Grey_Night }))),
                    React.createElement(Icon, { name: IconTokens.RightBlackIcon, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { marginHorizontal: -16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
                React.createElement(TouchableOpacity, { style: {
                        paddingHorizontal: 16,
                        paddingVertical: 18,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        backgroundColor: 'white',
                        alignItems: 'center',
                        alignContent: 'center'
                    }, onPress: () => {
                        triggerAction({
                            ...faqsAction
                        });
                    } },
                    React.createElement(View, { style: {
                            flexDirection: 'row', alignItems: 'center',
                            alignContent: 'center'
                        } },
                        React.createElement(Img, { source: { uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/faq.png" }, style: { width: 24, height: 24 } }),
                        React.createElement(View, { style: { marginLeft: 8 } },
                            React.createElement(Typography, { label: "FAQs", typeDLS: TypographyTypeDLS.B1M, lineHeight: 20, color: ColorTokens.Grey_Night }))),
                    React.createElement(Icon, { name: IconTokens.RightBlackIcon, size: IconSizeTokens.XXL, color: ColorTokens.Grey_Night })))),
        howItWorks && renderHowItWorksCard(),
        onEditLimitPressed && renderEditLimitConfirmationBox()));
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').height - 70 : Dimensions.get('window').height - 114,
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14
    },
    frameButtonContainer: {
        elevation: 24,
        height: Platform.OS !== "web" ? 44 : 40,
        backgroundColor: '#1434CB',
        flexDirection: 'row',
        marginHorizontal: 16,
        justifyContent: 'center',
        alignItems: 'center',
    },
    eligibleText: {
        paddingVertical: 12,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 8,
    },
    iconContainer: {
        paddingVertical: 12,
        justifyContent: 'center',
    },
});
export default (ManageLimitLanding);
